<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col xs:w-full sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 glow">
      <vx-card>
        <div slot="no-body" class="d-theme-dark-bg">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col grey-bg xs:w-full lg:w-1/2 xl:w-1/2 ">
              <div style="height: 288px;" >
                <span class="helper"></span>
                <img src="@/assets/images/pages/login.png"
                  alt="login"
                  class="mx-auto" />
              </div>
            </div>

            <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Connexion</h4>
                  <p>Bonjour, connectez-vous pour accéder à votre compte.</p>
                </div>

                <div>
                  <vs-input
                    name="email"
                    type="text"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Mot de passe"
                    v-model="password"
                    class="w-full mt-6"
                  />
                  <!-- ACTUALY USELESS -->
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                      >Se souvenir de moi</vs-checkbox
                    >
                    <router-link to="/resetpassword">Mot de passe oublié?</router-link>
                  </div>
                  <vs-alert
                    color="danger"
                    icon="new_releases"
                    v-if="hasError"
                    >{{ error_msg }}</vs-alert
                  >
                  <!-- Register & Login button -->
                  <vs-button type="border hidden-btn" color="primary">S'inscrire</vs-button>
                  <vs-button class="float-right login-btn" @click="login" color="primary"
                    >Se connecter</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
export default {
	name: "login",
	data() {
		return {
			email: "",
			password: "",
			checkbox_remember_me: false,
			apiUrl: this.$store.state.backendApiUrl,
			hasError: false,
			error_msg: ""
		};
	},
	methods: {
		/**
		 * Query API to login or not the user
		 */
		login() {
			if(this.email == "" || this.password == "")
				this.$vs.notify({
					title: "Erreur",
					text: "Remplissez tout les champs pour vous connecter",
					color: "danger"
				});
			// //console.log(this.email, this.password)
			this.$http
				.post(this.apiUrl + "users/login", {
					email: this.email,
					password: this.password
				})
				.then(response => {
					if(response.data) {
						if(response.data.user.userRole.slice(-1) == "0") throw "Pas d'accès au dashboard"; //Changer pour différent de 1 ?
						
						// The backend token does not expire; keep the cookies for a year
						// so the session survives (default was 1 day). Logout removes them.
						VueCookies.set("nid", response.data.access_token, "1y");
						VueCookies.set("kb", response.data.permission_token, "1y");
						VueCookies.set("aspi", response.data.status_token, "1y");
						//console.log(response.data);
						//console.log("updateData");
						this.$store.dispatch("updateUserInfo", response.data.user);
						this.$acl.change(response.data.user.userRole);
						this.$router.push({name: "home"})
							.catch(err => {
								//console.log("Erreur push : ", err);
							});
						this.$vs.notify({
							title: "Succès",
							text: "La connexion a été établie avec succès"
						});
					}
				})
				.catch(err => {
					this.$vs.notify({
						title: "Erreur",
						text: "La connexion a échoué",
						color: "danger"
					});
					console.error(err);
				});
		}
	}
};
</script>

<style lang="scss">
#page-login {
  .hidden-btn {
    visibility: hidden;
  }
  .login-btn {
    margin-top: 10px;
  }
  .grey-bg{
    background-color: #f8f8f8;
    width: 100%;
  }
  .helper {
    display: inline-block;
    height: 30%;
    vertical-align: middle;
  }
  .glow{
    box-shadow: 0px 0px 15px 5px rgba(7, 237, 230, 0.82);
  }
  img {
    vertical-align: middle;
  }
}
</style>
